module.exports = __webpack_public_path__ + "img/awesome.5e7e2b54.gif";